export const jsonify = (json) => {
   if (json) {
        let newResponse = json
            .replace(/\\n/g, '\\n')
            .replace(/\\'/g, "\\'")
            .replace(/\\"/g, '\\"')
            .replace(/\\&/g, '\\&')
            .replace(/\\r/g, '\\r')
            .replace(/\\t/g, '\\t')
            .replace(/\\b/g, '\\b')
            .replace(/\\f/g, '\\f');
        // Remove non-printable and other non-valid JSON chars
        newResponse = newResponse.replace(/[\u0000-\u0019]+/g, '');
        newResponse = newResponse.replace(/:,/g, ':null,');
        if (!newResponse) return;
        // Save this to state below so can access in rest of application.
        let data = JSON.parse(newResponse).data;
        return data;
    }
};

export const checkStatus = (response) => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    }
    const error = new Error(`HTTP Error: ${response.statusText}`);
    error.status = response.statusText;
    error.response = response;
};
export const parseJSON = (response) => {
    if (response) return response.json();
};



// WEBPACK FOOTER //
// ./src/components/Modals/VolumeModal/functions.js